import React, { useEffect, useState } from "react";
import { soundSources } from "../utils";

export const AudioItem = ({ audio, shouldPlay }) => {
  const [sound, setSound] = useState(new Audio());

  useEffect(() => {
    sound.pause();
    if (audio) {
      setSound((prev) => {
        prev.setAttribute(
          "src",
          soundSources.filter((e) => e.includes(audio))[0]
        );
        prev.setAttribute("loop", true);
        return prev;
      });
    } else {
      setSound((prev) => {
        prev.pause();
        prev.setAttribute("src", "");
        prev.setAttribute("loop", false);
        return prev;
      });
    }
  }, [audio, sound]);

  useEffect(() => {
    if (sound && !shouldPlay) {
      sound.pause();
    } else if (sound.src && shouldPlay) {
      let isPlaying =
        sound.currentTime > 0 &&
        !sound.paused &&
        !sound.ended &&
        sound.readyState > sound.HAVE_CURRENT_DATA;

      sound.load();
      !isPlaying && sound.play();
    }
  }, [shouldPlay, sound.src, sound, sound.paused]);

  return <></>;
};
